import { HttpService } from "../http/HttpService";
import { GenericUnPagedListResponse, ListSessionUserPaymentsRequest, PaymentMediumProjection, PlayerToPlayerTransferRequest, PlayerTransactionsRequest, PlayerTransactionsResponse, UpdatePaymentResponse } from "../http/protocol";


export class TransactionService {
    constructor(private http: HttpService) { }

    listTransactions(req: PlayerTransactionsRequest): Promise<PlayerTransactionsResponse> {
        return this.http.post("/transaction/list", req);
    }

    transferToPlayer(req: PlayerToPlayerTransferRequest): Promise<PlayerToPlayerTransferRequest> {
        return this.http.post("/transaction/transfer-to-player", req);
    }

    listPaymentsTransactions(req: ListSessionUserPaymentsRequest): Promise<GenericUnPagedListResponse<PaymentMediumProjection>> {
        return this.http.post("/payments/list-projections", req);
    }

    cancelPayment(id: string): Promise<UpdatePaymentResponse> {
        return this.http.get(`/payments/withdraw/cancel/${id}`);
    }


}
